import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-around;
  color: #98a6af;
  padding: .3em;
  background-color: #121723;
  
  span {
    min-width: 5rem;
  }
`
